import React from 'react';
import { useTranslation } from 'react-i18next';
import { type BiEvent } from '@wix/da-bi/pkg/events';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { sanitizeHref } from '@wix/da-url';

import s from './CreatedWithBanner.scss';

interface Props {
  logo: React.ReactNode;
  titleText?: string;
  ctaText?: string;
  linkHref?: string;
  linkOnClick?: () => void;
  linkBiData?: BiEvent;
  createdWithPrefix?: boolean;
}

const CreatedWithBanner: React.FC<Props> = ({
  logo,
  titleText,
  ctaText,
  linkHref,
  linkOnClick,
  linkBiData,
  createdWithPrefix,
}) => {
  const { t } = useTranslation();

  return (
    <div className={s['root']}>
      {createdWithPrefix && (
        <div className={s['prefix']}>{t('deviation.details.createdWith.prefix')}</div>
      )}
      <PlainButtonOrLink
        className={s['created-with']}
        href={linkHref ? sanitizeHref(linkHref) : undefined}
        onClick={linkOnClick}
        biData={linkBiData}
      >
        {logo}
        <div className={s['content']}>
          {titleText && <div className={s['title']}>{titleText}</div>}
          {ctaText && <div className={s['cta']}>{ctaText}</div>}
        </div>
      </PlainButtonOrLink>
    </div>
  );
};
CreatedWithBanner.displayName = 'CreatedWithBanner';

export default CreatedWithBanner;
